import React, { FC } from 'react';
import { ArrowType, KINTEKI, ENTEKI, MAKIWARA } from '@app/react/const/type';
import { KINTEKI_NAME, ENTEKI_NAME, MAKIWARA_NAME } from '@app/react/const/variables';

const key2name = {
    [KINTEKI]: KINTEKI_NAME,
    [ENTEKI]: ENTEKI_NAME,
    [MAKIWARA]: MAKIWARA_NAME,
};

// eslint-disable-next-line max-len
const id = 'M11.2-18.928A9.556,9.556,0,0,0,1.512-9.3,9.515,9.515,0,0,0,11.2.308a9.533,9.533,0,0,0,9.688-9.6A9.556,9.556,0,0,0,11.2-18.928Zm0,18.116A8.286,8.286,0,0,1,2.8-9.3a8.293,8.293,0,0,1,8.4-8.512A8.293,8.293,0,0,1,19.6-9.3,8.286,8.286,0,0,1,11.2-.812ZM24.416,0h1.12V-6.132c0-1.428.028-4.48,2.324-4.48a1.293,1.293,0,0,1,.84.224l.56-1.008a2.654,2.654,0,0,0-1.2-.28,2.7,2.7,0,0,0-2.52,1.736v-1.484h-1.12ZM40.992-9.436a5.172,5.172,0,0,0-4.424-2.24c-2.772,0-5.6,1.736-5.6,5.908,0,4,2.716,6.076,5.6,6.076a5.205,5.205,0,0,0,4.424-2.352V0h1.12V-20.412h-1.12Zm-4.424-1.176c2.828,0,4.48,2.156,4.48,4.816,0,3.332-2.156,5.04-4.424,5.04-2.3,0-4.48-1.708-4.48-5.04C32.144-8.988,34.216-10.612,36.568-10.612Zm19.8,5.04c0-3.64-2.324-6.1-5.4-6.1-2.8,0-5.544,2.044-5.544,6.02,0,3.332,2.072,5.964,5.628,5.964A5.52,5.52,0,0,0,56.056-2.8L55.1-3.36a4.36,4.36,0,0,1-3.976,2.6,4.587,4.587,0,0,1-4.536-4.816ZM46.676-6.636a4.366,4.366,0,0,1,4.284-3.976,4.29,4.29,0,0,1,4.228,3.976ZM59.668,0h1.12V-6.132c0-1.428.028-4.48,2.324-4.48a1.293,1.293,0,0,1,.84.224l.56-1.008a2.654,2.654,0,0,0-1.2-.28,2.7,2.7,0,0,0-2.52,1.736v-1.484h-1.12Zm23.1-17.556v-1.12H71.848v1.12h4.844V0h1.232V-17.556Zm5.432,5.88a5.894,5.894,0,0,0-5.992,5.992A5.894,5.894,0,0,0,88.2.308a5.894,5.894,0,0,0,5.992-5.992A5.894,5.894,0,0,0,88.2-11.676Zm0,10.92a4.789,4.789,0,0,1-4.816-4.928A4.789,4.789,0,0,1,88.2-10.612a4.789,4.789,0,0,1,4.816,4.928A4.789,4.789,0,0,1,88.2-.756Zm12.488-9.6v-1.064H98.7v-4.088H97.58v4.088H96.32v1.064h1.26V0H98.7V-10.36Zm11.536.924a5.215,5.215,0,0,0-4.452-2.24c-3.332,0-5.572,2.436-5.572,5.964,0,3.752,2.576,6.02,5.572,6.02a5.218,5.218,0,0,0,4.452-2.352V0h1.12V-11.424h-1.12Zm-4.4-1.176A4.49,4.49,0,0,1,112.28-5.8c0,2.632-1.568,5.04-4.424,5.04-2.884,0-4.48-2.464-4.48-5.04A4.487,4.487,0,0,1,107.828-10.612Zm9.548-9.8V0h1.12V-20.412Z';

const Icon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="116.984"
        height="20.72"
        viewBox="0 0 116.984 20.72"
    >
        <path
            id="パス_591"
            data-name="パス 591"
            d={id}
            transform="translate(-1.512 20.412)"
            fill="#333"
        />
    </svg>
);

interface OrderTotalValueComponentProps {
    price: number;
    arrowType: ArrowType;
    unitName: string | null;
    arrowlengthName: string;
    shipDate: string;
}

export const OrderTotalValueComponent: FC<OrderTotalValueComponentProps> = ({
    price,
    arrowType,
    unitName,
    arrowlengthName,
    shipDate,
}) => (
    <div className="order-total-value">
        <p className="order-total-value__detail-info">
            <span>{key2name[arrowType]}</span>
            ／
            <span>{unitName}</span>
            ／
            <span>{arrowlengthName}</span>
            ／
            <span>{shipDate}</span>
            発送予定
        </p>
        <div className="order-total-value__div">
            <Icon />
            <p className="price">
                <span>¥ </span>
                {price.toLocaleString()}
                <span className="smaller">（税込）</span>
            </p>
        </div>
    </div>
);
